import Notifications from '../../../settings/components/Notifications';

const NotificationPage = () => {
    return <Notifications />;
};

export default NotificationPage;
